module.exports = {
  email: 'altarhonymohammed@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/QassimAltarhouni',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/zion.zayoun/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/mohammed-altarhouni-672694173/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    // {
    //   name: 'Media',
    //   url: '/#media',
    // },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#f6c177',
    navy: '#0f1629',
    darkNavy: '#0c0f1f',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
